module.exports = __webpack_public_path__ + "static/33-1a53a8826b965ba52ef3f873d93ba22b.png";